const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const isEnabled = Boolean(GA_ID);

export function initAnalytics() {
  if (!isEnabled || typeof window === 'undefined') return;
  if (window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView(path, title) {
  if (!isEnabled || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!isEnabled || !window.gtag) return;
  window.gtag('event', name, params);
}

export function trackProductView(product) {
  if (!product) return;
  trackEvent('view_item', {
    items: [{
      item_id: product.id || product._id,
      item_name: product.name,
      item_category: product.category?.name || product.category,
      price: product.price,
    }],
  });
}
